<template>
  <SidebarComponent />
  <div class="dashboard-layout">
    <div class="content-container">
      <div class="card-container">
        <div class="titolo-card">
          <div class="title-row">
            <h1>Conversazione Nutrizionale</h1>
            <button class="icon-button" @click="viewUserDetails(user.uid)" title="Vedi utente">
              <span class="material-icons">visibility</span>
            </button>
          </div>

          <div class="summary-grid">
            <div class="summary-item">
              <span class="summary-label">Email</span>
              <span class="summary-value">{{ user.email || '—' }}</span>
            </div>
            <div class="summary-item">
              <span class="summary-label">Nome e cognome</span>
              <span class="summary-value">{{ [user.name, user.surname].filter(Boolean).join(' ') || '—' }}</span>
            </div>
            <div class="summary-item">
              <span class="summary-label">Studio</span>
              <span class="summary-value">{{ user.studio || '—' }}</span>
            </div>
            <div class="summary-item summary-order">
              <span class="summary-label">Ultimo ordine</span>
              <span class="summary-value" v-if="lastOrderInfo.state === 'loading'">Caricamento…</span>
              <span class="summary-value" v-else-if="lastOrderInfo.state === 'empty'">Nessun ordine trovato</span>
              <div class="summary-order__content" v-else>
                <span class="order-name">{{ lastOrderInfo.name }}</span>
                <span class="order-status" v-if="lastOrderInfo.status && lastOrderInfo.status !== '—'">{{ lastOrderInfo.status }}</span>
                <span class="order-meta">{{ lastOrderInfo.date }} · {{ lastOrderInfo.total }}</span>
              </div>
            </div>
          </div>
        </div>

        <p v-if="ticketStatus === 'Completato'" class="completed-text">Ticket Completato, rispondendo, questo ticket verrà riaperto</p>

        <!-- Conversazioni -->
        <ul class="ticket-container">
          <li
            v-for="(item, index) in mergedConversations"
            :key="index"
            :class="{'user-message': item.type === 'Richiesta', 'trainer-message': item.type === 'Nutrizionista'}"
            class="message-row"
          >
            <!-- Mostra messaggi -->
            <div v-if="item.type" class="message-info">
              <strong>{{ item.type }} ({{ formatDate(item.timestamp) }}):</strong>
            </div>
            <div v-if="item.content" class="message-content" v-html="item.content"></div>

            <!-- Mostra i documenti nella conversazione -->
            <div v-if="item.fileUrl && item.visibilityProfile" class="attached-file">
              <strong>File Allegato:</strong>
              <a :href="item.fileUrl" target="_blank">{{ item.fileName }}</a>
            </div>
          </li>
        </ul>

        <!-- Input messaggio -->
        <div v-if="showInputField" class="input-container">
          <textarea v-model="newResponse.content" class="response-textarea" placeholder="Inserisci la tua risposta" rows="4" cols="50"></textarea>
          <button @click="submitResponse" class="submit-button-conversation">Invia</button>
        </div>

        <div class="input-container2">
          <button v-if="noVisible" @click="toggleInputField" class="action-button">Rispondi</button>
          <button @click="goBackToTickets" class="action-button">Torna ai Ticket da rispondere</button>
          <button v-if="noVisible" @click="markAsCompleted" class="action-button">Completa</button>
          <select v-if="noVisible" v-model="ticketType" @change="updateTicketType($event, ticketId)" class="elegant-select">
            <option value="" disabled>Seleziona</option>
            <option value="tecnico">Tecnico</option>
            <option value="generale">Generale</option>
          </select>
        </div>

        <!-- Sezione Documenti -->
        <div class="documents-section">
          <h2>Documenti Allegati</h2>
          <input
            type="file"
            @change="uploadDocument"
            accept="application/pdf, image/jpeg, image/png"
            class="upload-input"
          />
          <ul v-if="filteredDocuments.length">
            <li v-for="(doc, index) in filteredDocuments" :key="'filtered-doc-' + index">
              <a :href="doc.fileUrl" target="_blank">{{ doc.fileName }}</a>
              <span>({{ doc.fileType }})</span>
              <button class="staff-button-danger" @click="deleteDocument(doc.id)">Elimina</button>
            </li>
          </ul>
          <p v-else class="no-documents">Nessun documento visibile per questo utente.</p>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { ref, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import {
  getFirestore,
  updateDoc,
  doc,
  getDoc,
  getDocs,
  deleteField,
  collection,
  addDoc,
  deleteDoc,
  query,
  where,
} from 'firebase/firestore';
import {
  getStorage,
  ref as storageRef,
  uploadBytes,
  getDownloadURL,
  deleteObject,
} from 'firebase/storage';
import SidebarComponent from '../SidebarComponent.vue';

export default {
  components: {
    SidebarComponent,
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const ticketId = route.params.ticketId;
    const db = getFirestore();
    const conversations = ref([]);
    const documents = ref([]);
    const showInputField = ref(false);
    const newResponse = ref({
      content: '',
      fileUrl: '',
      fileName: '',
    });
    const ticketStatus = ref('');
    const ticketType = ref('');
    const user = ref({
      email: '',
      name: '',
      surname: '',
      studio: '',
      uid: '',
    });
    const lastOrder = ref(null);
    const lastOrderLoading = ref(false);

// Computed property per filtrare i documenti
const filteredDocuments = computed(() => {
  return documents.value.filter(doc => doc.visibilityProfile === true && doc.uploadCategory === "Alimentazione");
});


    // Aggiornare `mergedConversations` per includere solo documenti visibili
const mergedConversations = computed(() => {
  // Combine messages and documents into one array
  const combinedItems = [
    ...conversations.value,
    ...filteredDocuments.value.map(doc => ({
      type: 'Document', // Custom type for differentiation
      timestamp: doc.uploadedAt,
      fileUrl: doc.fileUrl,
      fileName: doc.fileName,
      visibilityProfile: doc.visibilityProfile
    }))
  ];

  // Sort combined items by timestamp
  combinedItems.sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp));

  return combinedItems;
});


    const parseOrderDate = (order) => {
      const candidates = [order?.orderDate, order?.importedAt, order?.updatedAt, order?.createdAt];
      for (const value of candidates) {
        if (!value) continue;
        if (typeof value?.toDate === 'function') {
          const date = value.toDate();
          if (date instanceof Date && !Number.isNaN(date.getTime())) return date;
        }
        const parsed = new Date(String(value).replace(' ', 'T'));
        if (!Number.isNaN(parsed.getTime())) return parsed;
      }
      return null;
    };

    const formatOrderDateValue = (order) => {
      const date = parseOrderDate(order);
      if (!date) return 'Data n/d';
      return date.toLocaleDateString('it-IT', { dateStyle: 'medium' });
    };

    const formatOrderPrice = (value) => {
      const num = Number(value);
      if (!Number.isFinite(num)) return '—';
      return num.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' });
    };

    const fetchLastOrder = async (userEmail) => {
      const trimmedEmail = String(userEmail || '').trim();
      if (!trimmedEmail) {
        lastOrder.value = null;
        return;
      }
      lastOrderLoading.value = true;
      try {
        const ordersRef = collection(db, 'orders');
        const q = query(ordersRef, where('userEmail', '==', trimmedEmail));
        const snap = await getDocs(q);
        if (snap.empty) {
          lastOrder.value = null;
          return;
        }
        const sorted = snap.docs
          .map(orderSnap => ({ id: orderSnap.id, ...orderSnap.data() }))
          .sort((a, b) => {
            const bTime = parseOrderDate(b)?.getTime() ?? 0;
            const aTime = parseOrderDate(a)?.getTime() ?? 0;
            return bTime - aTime;
          });
        lastOrder.value = sorted[0] || null;
      } catch (error) {
        console.error("Errore durante il recupero dell'ultimo ordine:", error);
        lastOrder.value = null;
      } finally {
        lastOrderLoading.value = false;
      }
    };

    const formatOrderStatus = (status) => {
      if (!status) return '—';
      return String(status)
        .replace(/[_-]+/g, ' ')
        .replace(/\b\w/g, (c) => c.toUpperCase());
    };

    const lastOrderInfo = computed(() => {
      if (lastOrderLoading.value) return { state: 'loading' };
      if (!lastOrder.value) return { state: 'empty' };

      const order = lastOrder.value;
      const code = order.orderId || order._id || order.id || '—';
      const name = order.products?.[0]?.name || `Ordine ${code}`;
      const date = formatOrderDateValue(order);
      const total = formatOrderPrice(order.totalPrice);
      const status = formatOrderStatus(order.status || order.paymentStatus);

      return {
        state: 'ready',
        code,
        name,
        date,
        total,
        status,
      };
    });


    const store = useStore();
    const userRole = ref(store.getters.userRole);
    const noVisible = computed(() => userRole.value !== 'Studio');

    const enableDocumentUploadByDefault = async (userDocRef, userData) => {
      if (typeof userData.canUploadNutritionalFiles === 'boolean') {
        return userData;
      }

      await updateDoc(userDocRef, { canUploadNutritionalFiles: true });
      return {
        ...userData,
        canUploadNutritionalFiles: true,
      };
    };

    // Carica le conversazioni
    const fetchConversation = async () => {
      const ticketRef = doc(db, 'tickets', ticketId);
      const ticketSnapshot = await getDoc(ticketRef);

      if (ticketSnapshot.exists()) {
        const data = ticketSnapshot.data();
        conversations.value = data.conversations || [];
        ticketStatus.value = data.status;

        if (data.userId) {
          const userRef = doc(db, 'users', data.userId);
          const userSnapshot = await getDoc(userRef);
          if (userSnapshot.exists()) {
            user.value = await enableDocumentUploadByDefault(userRef, userSnapshot.data());
            if (!user.value.uid) user.value.uid = data.userId;
            await fetchDocuments(data.userId); // Recupera i documenti associati
            await fetchLastOrder(user.value.email);
          } else {
            console.error('Dettagli utente non trovati');
          }
  
        }
      } else {
        console.error('Ticket non trovato');
      }
    };

    // Carica i documenti
    const fetchDocuments = async (userId) => {
      try {
        const targetUserId = userId || user.value?.uid;
        if (!targetUserId) {
          documents.value = [];
          return;
        }
        const docsRef = collection(db, 'documenti');
        const q = query(docsRef, where('userId', '==', targetUserId));
        const querySnapshot = await getDocs(q);

        documents.value = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
          uploadedAt: doc.data().uploadedAt.toDate(), // Converti il timestamp Firestore in oggetto Date
        }));
      } catch (error) {
        console.error('Errore durante il recupero dei documenti:', error);
      }
    };

    // Salva una risposta con o senza file
    const submitResponse = async () => {
      if (newResponse.value.content.trim() !== '') {
        const updatedConversations = [
          ...conversations.value,
          {
            type: 'Nutrizionista',
            content: newResponse.value.content,
            timestamp: new Date().toISOString(),
          },
        ];

        try {
          await updateDoc(doc(db, 'tickets', ticketId), {
            conversations: updatedConversations,
            status: 'Risposto',
          });

          alert('Risposta inviata con successo!');
          newResponse.value = { content: '', fileUrl: '', fileName: '' };
          showInputField.value = false;
          await fetchConversation();
        } catch (error) {
          console.error("Errore nell'invio della risposta:", error);
        }
      } else {
        alert('Il contenuto della risposta non può essere vuoto.');
      }
    };

    // Caricamento documenti
    const uploadDocument = async (event) => {
      const file = event.target.files[0];
      if (!file) return;

      if (file.size > 10 * 1024 * 1024) {
        alert('Il file supera i 10MB.');
        return;
      }

  // Verifica il tipo di file consentito
  const allowedFileTypes = ["pdf", "jpg", "jpeg", "png"];
  const fileType = allowedFileTypes.find((type) => file.type.includes(type));
  if (!fileType) {
    alert("Formato non supportato. Usa solo PDF, JPG, JPEG o PNG.");
    return;
  }

      try {
        const storage = getStorage();
        const filePath = `documenti/${user.value.uid}/${file.name}`;
        const fileRef = storageRef(storage, filePath);

        // Caricamento su Firebase Storage
        await uploadBytes(fileRef, file);
        const fileUrl = await getDownloadURL(fileRef);

        // Salvataggio su Firestore
        const docRef = collection(db, 'documenti');
        const newDoc = await addDoc(docRef, {
          userId: user.value.uid,
          fileUrl,
          fileName: file.name,
          fileType,
          uploadedAt: new Date(),
          uploadUser: "Amministrazione", // Campo statico
      visibilityProfile: true, // Nuovo campo statico
      uploadCategory: "Alimentazione",

        });

        documents.value.push({
          id: newDoc.id,
          fileUrl,
          fileName: file.name,
          fileType,
          uploadUser: "Amministrazione",
      visibilityProfile: true,
      uploadCategory: "Alimentazione",

        });

        alert('Documento caricato con successo!');
      } catch (error) {
        console.error('Errore durante il caricamento:', error);
        alert('Errore nel caricamento del documento.');
      }
    };

    const deleteDocument = async (docId) => {
      const docToDelete = documents.value.find((doc) => doc.id === docId);
      if (!docToDelete) return;

      if (!confirm('Sei sicuro di voler eliminare questo documento?')) return;

      try {
        const storage = getStorage();
        const fileRef = storageRef(storage, docToDelete.fileUrl);

        // Elimina il file da Firebase Storage
        await deleteObject(fileRef);

        // Elimina il documento da Firestore
        await deleteDoc(doc(db, 'documenti', docId));

        documents.value = documents.value.filter((doc) => doc.id !== docId);
        alert('Documento eliminato con successo!');
      } catch (error) {
        console.error('Errore durante l\'eliminazione del documento:', error);
      }
    };

    const markAsCompleted = async () => {
      try {
        await updateDoc(doc(db, 'tickets', ticketId), { status: 'Completato' });
        ticketStatus.value = 'Completato';
        alert('Ticket marcato come completato!');
      } catch (error) {
        console.error('Errore nel marcare il ticket come completato:', error);
      }
    };

    const formatDate = (timestamp) => {
      const date = new Date(timestamp);
      return date.toLocaleDateString('it-IT') + ' ' + date.toLocaleTimeString('it-IT');
    };

    const goBackToTickets = async () => {
      try {
        await updateDoc(doc(db, 'tickets', ticketId), { read: deleteField() });
        console.log("Campo 'read' rimosso con successo quando si torna ai ticket.");
      } catch (error) {
        console.error('Errore durante la rimozione del campo read:', error);
      }
      router.push('/admin');
    };

    const viewUserDetails = (userId) => {
      router.push({ name: 'UserDetails', params: { userId: userId } });
    };

    onMounted(() => {
      fetchConversation();
    });

    return {
      conversations,
      documents,
      mergedConversations,
      submitResponse,
      uploadDocument,
      deleteDocument,
      goBackToTickets,
      viewUserDetails,
      toggleInputField: () => (showInputField.value = !showInputField.value),
      showInputField,
      newResponse,
      ticketStatus,
      ticketType,
      markAsCompleted,
      formatDate,
      noVisible,
      user,
      filteredDocuments,
      lastOrderInfo,
    };
  },
};
</script>

<style scoped>

.documents-section {
  background-color: #f9f9f9; /* Colore di sfondo chiaro */
  padding: 1.5rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-bottom: 1.5rem;
}

.documents-section h2 {
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: #333; /* Colore del testo */
}

.documents-section input[type="file"] {
  margin-bottom: 1rem;
  padding: 0.5rem;
  font-size: 1rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
  transition: border-color 0.2s ease;
}

.documents-section input[type="file"]:hover {
  border-color: #007bff; /* Cambia il colore al passaggio del mouse */
}

.documents-section ul {
  list-style-type: none; /* Rimuove i puntini */
  padding: 0;
  margin: 0;
}

.documents-section li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 1rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-bottom: 0.75rem;
  background-color: #fff;
  transition: box-shadow 0.2s ease, background-color 0.2s ease;
}

.documents-section li:hover {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1); /* Aggiunge un'ombra al passaggio del mouse */
  background-color: #f0f8ff; /* Sfondo leggermente colorato */
}

.documents-section a {
  color: #007bff;
  text-decoration: none;
  font-weight: 500;
  flex: 1; /* Permette al link di occupare più spazio */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.documents-section a:hover {
  text-decoration: underline;
}

.documents-section span {
  font-size: 0.875rem;
  color: #666;
  margin-left: 1rem;
}

.documents-section button {
  background-color: #dc3545; /* Rosso */
  color: #fff;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.875rem;
  transition: background-color 0.2s ease;
}

.documents-section button:hover {
  background-color: #c82333; /* Rosso scuro al passaggio del mouse */
}

.documents-section p {
  font-size: 0.875rem;
  color: #666;
  margin: 1rem 0 0;
  text-align: center;
}


.ticket-container {
  margin-top: 24px;
}
.documents-section {
  margin-top: 10px;
}

.content-container {
  margin-top: 0px;
}

.titolo-card {
  position: sticky;
  top: 24px;
  display: flex;
  flex-direction: column;
  gap: 18px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 18px;
  padding: 22px 26px;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.08);
  backdrop-filter: blur(2px);
}

.titolo-card h1 {
  margin: 0;
  font-size: 1.6rem;
  font-weight: 700;
  color: #0f172a;
}

.title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.icon-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  color: #0f172a;
  transition: all 0.2s ease;
  cursor: pointer;
}

.icon-button:hover {
  background: #eef2ff;
  border-color: #c7d2fe;
  color: #312e81;
}

.summary-grid {
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
}

.summary-item {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.summary-label {
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #64748b;
}

.summary-value {
  font-size: 0.95rem;
  font-weight: 600;
  color: #0f172a;
  line-height: 1.35;
}

.summary-order__content {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 0.95rem;
  font-weight: 600;
  color: #0f172a;
}

.summary-order .order-name {
  font-weight: 600;
  color: #1d4ed8;
}

.summary-order .order-status {
  display: inline-flex;
  align-items: center;
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #475569;
}

.summary-order .order-meta {
  font-size: 0.82rem;
  color: #475569;
}

.message-row {
  margin-bottom: 20px;
}

.message-info {
  font-weight: bold;
  margin-bottom: 5px;
}

.message-content {
  white-space: pre-wrap;
}

/* Profilo utente link */
.profile-link {
  cursor: pointer;
  text-decoration: underline;
  color: rgb(0, 125, 2);
}

.profile-link:hover {
  color: rgb(47, 165, 0);
}


.completed-text {
  color: red;
  font-weight: bold;
  margin-bottom: 10px;
}


/* Per la textarea di risposta */


/* Pulsante per inviare la risposta */
.submit-button-conversation {
  padding: 10px 20px;
  background-color: #006200;
  color: white;
  border: none;
  border-radius: 13px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.submit-button-conversation:hover {
  background-color: #45a049; /* Effetto hover */
}

/* Container per input e pulsante */
.input-container2 {
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: center;
  width: 100%;
  margin-bottom: 50px;
}

/* Stili per i pulsanti generici */
.action-button {
  padding: 10px 20px;
  background-color: #006200;
  color: white;
  border: none;
  border-radius: 13px;
  cursor: pointer;
  height: 50px;

}

.action-button:hover {
  background-color: #088608;
}


</style>
